import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "../../Components/Spinner/Spinner";
import Pagination from "../../Components/Pagination/Pagination";
import UpdatePaymentStatus from "./UpdatePaymentStatus"; 
import { useGetBookingsQuery } from "../../Services/api";
import moment from "moment";

const OrderManagement = () => {
  const [page, setPage] = useState(1);
  const limit = 10;

  const [params, setParams] = useState({
    page: 1,
    limit,
    search: "",
    status: "",
    transaction_id: "",
    amountMin: "",
    amountMax: "",
    fromDate: "",
    toDate: "",
    sortField: "createdAt",
    sortOrder: "desc",
  });

  const { data, isLoading, isError, refetch } = useGetBookingsQuery(
    params,
    { refetchOnMountOrArgChange: true }
  );

  const [showModal, setShowModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  useEffect(() => {
    setParams((p) => ({ ...p, page }));
  }, [page]);

  useEffect(() => {
    setPage(1);
    refetch();
  }, [
    params.search,
    params.status,
    params.transaction_id,
    params.amountMin,
    params.amountMax,
    params.fromDate,
    params.toDate,
    params.sortField,
    params.sortOrder,
    refetch,
  ]);

  if (isLoading) return <Spinner />;
  if (isError) return <p className="text-danger">Error loading bookings.</p>;

  const bookingList = data?.data?.booking_list || [];
  const totalPages = data?.data?.total_pages || 1;
  const totalEntries = data?.data?.total || 0;
  const nextPage = data?.data?.next_page || null;

  const beverageCount = (bevArr) =>
    bevArr.reduce((sum, b) => sum + (b.selected_count || 0), 0);
  const beverageTotal = (bevArr) =>
    bevArr.reduce((sum, b) => sum + (b.total_price || 0), 0);

  const handleSort = (field) => {
    setParams((p) => ({
      ...p,
      sortField: field,
      sortOrder:
        p.sortField === field && p.sortOrder === "desc" ? "asc" : "desc",
    }));
  };

  // Improved Sort Indicator
  const SortIndicator = ({ field }) => {
    if (params.sortField === field) {
      return params.sortOrder === "desc" ? " 🔽" : " 🔼";
    }
    return " ↕"; // default faint arrow when not active
  };

  const handleChangePaymentStatus = (bookingId) => {
    setSelectedBookingId(bookingId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBookingId(null);
  };

  return (
    <>
      {/* Filters */}
      <div className="mb-4 p-3 bg-light rounded shadow-sm">
        <Row className="g-3 align-items-center">
          <Col md={3}>
          <label className="small text-muted mb-1">🔍 Search orders...</label>
            <input
              className="form-control"
              placeholder="Search by user & event..."
              value={params.search}
              onChange={(e) => setParams((p) => ({ ...p, search: e.target.value }))}
            />
          </Col>

          <Col md={2}>
          <label className="small text-muted mb-1">Select Payment Type</label>
            <select
              className="form-select"
              value={params.status}
              onChange={(e) => setParams((p) => ({ ...p, status: e.target.value }))}
            >
              <option value="">All Payments</option>
              <option value="2">✅ Done</option>
              <option value="1">⌛ Pending</option>
            </select>
          </Col>

          <Col md={2}>
          <label className="small text-muted mb-1">🧾 Transaction ID</label>
            <input
              className="form-control"
              placeholder="Enter transaction id..."
              value={params.transaction_id}
              onChange={(e) => setParams((p) => ({ ...p, transaction_id: e.target.value }))}
            />
          </Col>

          
              <Col>
                <div className="d-flex flex-column">
                  <label className="small text-muted mb-1">📅 From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={params.fromDate}
                    onChange={(e) => setParams((p) => ({ ...p, fromDate: e.target.value }))}
                  />
                </div>
              </Col>
              <Col>
                <div className="d-flex flex-column">
                  <label className="small text-muted mb-1">📅 To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={params.toDate}
                    onChange={(e) => setParams((p) => ({ ...p, toDate: e.target.value }))}
                  />
                </div>
              </Col>
            
        </Row>
      </div>

      {/* Table */}
      <div className="common-table-wrapper">
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th className="text-white">#</th>
                <th className="text-white">User</th>
                <th className="text-white">Phone</th>
                <th
                  className="text-white"
                  onClick={() => handleSort("event_data.event_name")}
                  style={{ cursor: "pointer" }}
                >
                  Event<SortIndicator field="event_data.event_name" />
                </th>
                <th
                  className="text-white"
                  onClick={() => handleSort("no_of_ticket")}
                  style={{ cursor: "pointer" }}
                >
                  Tickets<SortIndicator field="no_of_ticket" />
                </th>
                <th
                  className="text-white"
                  onClick={() => handleSort("amount")}
                  style={{ cursor: "pointer" }}
                >
                  Amount<SortIndicator field="amount" />
                </th>
                <th className="text-white">Payment Status</th>
                <th className="text-white">Transaction ID</th>
                <th className="text-white">Beverages (Count/Price)</th>
                <th
                  className="text-white"
                  onClick={() => handleSort("createdAt")}
                  style={{ cursor: "pointer" }}
                >
                  Last Updated<SortIndicator field="createdAt" />
                </th>
                <th className="text-white">Action</th> {/* New Action Column */}
              </tr>
            </thead>
            <tbody>
              {bookingList.length > 0 ? (
                bookingList.map((b, i) => {
                  const bevCount = beverageCount(b.beverage);
                  const totalTickets = b.no_of_ticket + bevCount;
                  return (
                    <tr key={b._id}>
                      <td>{(page - 1) * limit + i + 1}</td>
                      <td>{b.user_data?.first_name}</td>
                      <td>{b.user_data?.phone}</td>
                      <td>{b.event_data?.event_name}</td>
                      <td>{totalTickets}</td>
                      <td>₹{b.amount.toFixed(2)}</td>
                      <td>
                        {b.status === 2 ? (
                          <span className="badge bg-success">Done</span>
                        ) : (
                          <span className="badge bg-warning text-dark">Pending</span>
                        )}
                      </td>
                      <td>{b.transaction_id}</td>
                      <td>
                        {bevCount} / ₹{beverageTotal(b.beverage).toFixed(2)}
                      </td>
                      <td>{moment(b.createdAt).format("DD-MMM-YYYY hh:mm A")}</td>
                      <td>
                        {b.status === 1 && (
                          <button
                          className="btn btn-warning btn-sm"
                          onClick={() => handleChangePaymentStatus(b._id)}
                          style={{ 
                            padding: '2px 8px',
                            fontSize: '0.8rem',
                            lineHeight: 1.2,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          Update Payment
                        </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={11} className="text-center">
                    No bookings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {bookingList.length > 0 && (
          <Row className="mt-3 px-2">
            <Col md={5}>
              <div className="dataTables_info text-muted">
                {`Showing ${Math.min((page - 1) * limit + 1, totalEntries)} to ${Math.min(page * limit, totalEntries)} of ${totalEntries} entries`}
              </div>
            </Col>
            <Col md={7} className="text-end">
              <Pagination
                total={totalPages}
                page={page}
                nextPage={nextPage}
                setPage={setPage}
              />
            </Col>
          </Row>
        )}
      </div>
       {/* Update Payment Status Popup */}
       <UpdatePaymentStatus
        show={showModal}
        handleClose={handleCloseModal}
        bookingId={selectedBookingId}
      />
    </>
  );
};

export default OrderManagement;
